const state = {
  monitor_mqttMessages: [],   //监控大屏mqtt数据

  //用户行为信息的数据
  userEventLog:[],

  //用户所有的行为信息
  userAllEventLog:[],
}

export default state;



// WEBPACK FOOTER //
// ./src/store/state/index.js